export const fetchZipCodeData = async (zipCode) => {
  try {
    const cleanedZip = zipCode.replace(/\D/g, '');

    if (cleanedZip.length !== 8) {
      throw new Error('CEP deve conter 8 dígitos');
    }

    const response = await fetch(`https://viacep.com.br/ws/${cleanedZip}/json/`);
    const data = await response.json();

    if (data.erro) {
      throw new Error('CEP não encontrado');
    }

    return {
      street: data.logradouro || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
      zipCode: data.cep || cleanedZip
    };
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    throw error;
  }
};